module.exports = __webpack_public_path__ + "static/media/EHallCorner-f.3227e43b.webp";